import { gql } from 'graphql-request';

import type { RequestDocument } from 'graphql-request';

export const COMPOSITION_CATEGORIES_QUERY_FRAGMENT: RequestDocument = gql`
  {
    id
    label
    order
    subcategories {
      id
    }
  }
`;

export const COMPOSITION_SUBCATEGORIES_QUERY_FRAGMENT: RequestDocument = gql`
  {
    id
    label
    order
    compositions {
      id
    }
  }
`;

export const COMPOSITION_SUBCATEGORIES_QUERY: RequestDocument = gql`
  query CompositionSubcategories($whitelistedCompositionsIds: [ItemId], $whitelistedSubcategoriesIds: [ItemId], $first: IntType, $skip: IntType) {
    allGraphicSubcategories(
      first: $first,
      skip: $skip,
      filter: { compositions: { anyIn: $whitelistedCompositionsIds }, id: { in: $whitelistedSubcategoriesIds } }
    ) ${COMPOSITION_SUBCATEGORIES_QUERY_FRAGMENT}
  }
`;

export const COMPOSITION_CATEGORIES_QUERY: RequestDocument = gql`
  query CompositionCategories($whitelistedSubcategoriesIds: [ItemId], $whitelistedCategoriesIds: [ItemId], $first: IntType, $skip: IntType) {
    allGraphicCategories(
      first: $first,
      skip: $skip,
      filter: { subcategories: { anyIn: $whitelistedSubcategoriesIds }, id: { in: $whitelistedCategoriesIds } }
    ) ${COMPOSITION_CATEGORIES_QUERY_FRAGMENT}
  }
`;
